// extracted by mini-css-extract-plugin
module.exports = {"container":"qozM3tE-IjCQkctxUpUL","item":"_1humxaEdTnahB_A05kvQP4","description":"_2zaUAPymBH_FyvQ5TOwPZC"};